import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6, ProgressBar } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useHistory } from "react-router-dom";


import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'
import svgdoubledown from './svg/double-chevron-down.svg'

import { PrintChqInfo } from './Types'
import { SystemHeader } from './CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;



interface PrintChqRtnProps {
    gsb: AxiosInstance,
    currentPrintChq?: PrintChqInfo,
    onChqProcess?: (Chq: PrintChqInfo) => void,
    onCancel?: () => void;
}

function PrintChqRtn({ gsb, currentPrintChq = {} as PrintChqInfo, onChqProcess = () => { }, onCancel = () => { } }: PrintChqRtnProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<PrintChqInfo>()

    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    

    const [Enter2tab, setEnter2tab] = useState("Y")

    const [IPAddr, setIPAddr] = useState("")

    const [ShowButton, setShowButton] = useState(true)
    
    const [BankCodeValue, setBankCodeValue] = useState(currentPrintChq.d_Bank_Code)
    const [CurrrencyValue, setCurrrencyValue] = useState(currentPrintChq.d_Currency)
    const [ChequeDateValue, setChequeDateValue] = useState(currentPrintChq.d_Cheque_Date)
    const [StartingChequeNoValue, setStartingChequeNoValue] = useState(currentPrintChq.d_Starting_Cheque_No)
    const [LPTValue, setLPTValue] = useState(currentPrintChq.d_LPT)


    useEffect(() => {
        // Call reset to get the values of record PfEntitInfo 
        if ("d_Bank_Code" in currentPrintChq) {
            reset(currentPrintChq)
        }
    }, [currentPrintChq, reset])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it (d_Market) manually and call setValue when item is selected
        //register({ name: "d_Dividend_Currency" })
    }, [register])


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setEnter2tab(GsbFlag.Enter2tab)               

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, currentPrintChq, GsbFlag])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [gsb, currentPrintChq, GsbFlag, Enter2tab])



    const onSubmit = (data: PrintChqInfo) => {

        setShowButton(false)

        data.d_Bank_Code = BankCodeValue;
        if ( typeof(data.d_Bank_Code) === "undefined" ) {
            data.d_Bank_Code = ""
        }
        data.d_Bank_Code = data.d_Bank_Code.toUpperCase();

        data.d_Currency = CurrrencyValue;
        data.d_Currency = data.d_Currency.toUpperCase();

        data.d_LPT = LPTValue;
        data.d_LPT = data.d_LPT.toUpperCase();

        data.d_Starting_Cheque_No = StartingChequeNoValue;
        if ( typeof(data.d_Starting_Cheque_No) === "undefined" ) {
            data.d_Starting_Cheque_No = "1"
        }

       

        (async () => {
            try {
                
                console.log("call PrintChqRtn data", data);

                
                const res = await gsb.post('/Transaction', {sb_data: data, cPgmId: "PayRecTranEntry", cAction: "PrintPayRecChqValidate" })
                //console.log("PrintChqRtn res.data.ok", res.data.ok)
                //console.log("PrintChqRtn res.data.daa", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    setShowButton(true)

                    return
                }

                onChqProcess(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

    }




    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Exit</Button>
                <Button className="Col-2-2" disabled={! ShowButton} icon="tick" onClick={handleSubmit(onSubmit)}>Print Cheque</Button>
             </div>
            <div className="Spacing-V-16" />

            <div className="Row">
                <FormGroup className="Col-1-2" label="Currency" labelFor="inputCurrency" labelInfo="*">
                    <InputGroup id="inputCurrency" value={CurrrencyValue} defaultValue="" placeholder="Currency ..." onChange={utils.handleStringChange(s => setCurrrencyValue(s)) } inputRef={register({ maxLength: 3}) } />
                    {errors.d_Currency && errors.d_Currency.type === "required" && <span id="Err_msg">Currency cannot be Blank</span>}
                    {errors.d_Currency && errors.d_Currency.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_Currency && errors.d_Currency.types && <span id="Err_msg">{errors.d_Currency.types.message}</span>}
                </FormGroup>
            </div>

            <div className="Row">
                <FormGroup className="Col-1-2" label="Bank Code" labelFor="inputBank_Code" labelInfo="*">
                    <InputGroup id="inputBank_Code" value={BankCodeValue} defaultValue="" placeholder="Bank Code ..." onChange={utils.handleStringChange(s => setBankCodeValue(s)) } inputRef={register({ required: true , maxLength: 8}) } />
                    {errors.d_Bank_Code && errors.d_Bank_Code.type === "required" && <span id="Err_msg">Bank Code cannot be Blank</span>}
                    {errors.d_Bank_Code && errors.d_Bank_Code.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_Bank_Code && errors.d_Bank_Code.types && <span id="Err_msg">{errors.d_Bank_Code.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Cheque Date" labelFor="inputCheque_Date">
                    <InputGroup id="inputCheque_Date" disabled={true} name="d_Cheque_Date" type="date" defaultValue={ChequeDateValue} placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_Cheque_Date && errors.d_Cheque_Date.types && <span id="Err_msg">{errors.d_Cheque_Date.types.message}</span>}
                </FormGroup>
            </div>
             
            <div className="Spacing-V-16" />

            <div className="Row">
                <FormGroup className="Col-1-2" label="Starting Cheque No" labelFor="inputChequeNo">
                    <InputGroup className="inputNumberNoSpin" id="inputChequeNo" defaultValue={StartingChequeNoValue} value={StartingChequeNoValue} type="number" onChange={utils.handleStringChange(n => setStartingChequeNoValue(n))}  />
                    {errors.d_Starting_Cheque_No && errors.d_Starting_Cheque_No.types && <span id="Err_msg">{errors.d_Starting_Cheque_No.types.message}</span>}
                </FormGroup>
            </div>

            <div className="Row">
                <FormGroup className="Col-1-2" label="XLPT" labelFor="inputLpt" labelInfo="*">
                    <InputGroup id="inputLpt" value={LPTValue} defaultValue="" placeholder="XLPT ..." onChange={utils.handleStringChange(s => setLPTValue(s)) } inputRef={register({ required: true ,maxLength: 5}) } />
                    {errors.d_LPT && errors.d_LPT.type === "required" && <span id="Err_msg">XLPT cannot be Blank</span>}
                    {errors.d_LPT && errors.d_LPT.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                    {errors.d_LPT && errors.d_LPT.types && <span id="Err_msg">{errors.d_LPT.types.message}</span>}
                </FormGroup>
            </div>

        </form>
    )
}


interface ResetChqRtnProps {
    gsb: AxiosInstance,
    currentPrintChq?: PrintChqInfo,
    onResetChqProcess?: (Chq: PrintChqInfo) => void,
    onCancel?: () => void;
}

function ResetChqRtn({ gsb, currentPrintChq = {} as PrintChqInfo, onResetChqProcess = () => { }, onCancel = () => { } }: ResetChqRtnProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<PrintChqInfo>()

    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    

    const [Enter2tab, setEnter2tab] = useState("Y")

    const [IPAddr, setIPAddr] = useState("")

    const [ShowButton, setShowButton] = useState(true)
    
    const [BankCodeValue, setBankCodeValue] = useState(currentPrintChq.d_Bank_Code)
    const [CurrrencyValue, setCurrrencyValue] = useState(currentPrintChq.d_Currency)
    const [ChequeDateValue, setChequeDateValue] = useState(currentPrintChq.d_Cheque_Date)
    const [ResetChequeNoValue, setResetChequeNoValue] = useState(currentPrintChq.d_Reset_Cheque_No)
    const [AutopayBankCodeValue, setAutopayBankCodeValue] = useState(currentPrintChq.d_Autopay_BankCode)


    useEffect(() => {
        // Call reset to get the values of record PfEntitInfo 
        if ("d_Bank_Code" in currentPrintChq) {
            reset(currentPrintChq)
        }
    }, [currentPrintChq, reset])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it (d_Market) manually and call setValue when item is selected
        //register({ name: "d_Dividend_Currency" })
    }, [register])


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setEnter2tab(GsbFlag.Enter2tab)               

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, currentPrintChq, GsbFlag])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [gsb, currentPrintChq, GsbFlag, Enter2tab])



    const onSubmit = (data: PrintChqInfo) => {

        setShowButton(false)

        data.d_Bank_Code = BankCodeValue;
        if ( typeof(data.d_Bank_Code) === "undefined" ) {
            data.d_Bank_Code = ""
        }
        data.d_Bank_Code = data.d_Bank_Code.toUpperCase();

        data.d_Currency = CurrrencyValue;
        data.d_Currency = data.d_Currency.toUpperCase();

        data.d_Reset_Cheque_No = ResetChequeNoValue;
        if ( typeof(data.d_Reset_Cheque_No) === "undefined" ) {
            data.d_Reset_Cheque_No = "1"
        }

        data.d_Autopay_BankCode = AutopayBankCodeValue;
        if ( typeof(data.d_Autopay_BankCode) === "undefined" ) {
            data.d_Autopay_BankCode = ""
        }
        data.d_Autopay_BankCode = data.d_Autopay_BankCode.toUpperCase();

       

        (async () => {
            try {
                
                console.log("call ResetChqRtn data", data);

                
                onResetChqProcess(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

    }



    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Exit</Button>
                <Button className="Col-2-4" disabled={! ShowButton} icon="tick" onClick={handleSubmit(onSubmit)}>Reset Payment Cheque No. / Autopay</Button>
             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Currency" labelFor="inputCurrency" labelInfo="*">
                    <InputGroup id="inputCurrency" value={CurrrencyValue} defaultValue="" placeholder="Currency ..." onChange={utils.handleStringChange(s => setCurrrencyValue(s)) } inputRef={register({ maxLength: 3}) } />
                    {errors.d_Currency && errors.d_Currency.type === "required" && <span id="Err_msg">Currency cannot be Blank</span>}
                    {errors.d_Currency && errors.d_Currency.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_Currency && errors.d_Currency.types && <span id="Err_msg">{errors.d_Currency.types.message}</span>}
                </FormGroup>
            </div>

            <div className="Row">
                <FormGroup className="Col-1-3" label="Reset Payment Cheque No. Starting From" labelFor="inputReset_Cheque_No" labelInfo="*">
                    <InputGroup id="inputReset_Cheque_No" value={ResetChequeNoValue} defaultValue="1" placeholder="Cheque No. ..." onChange={utils.handleStringChange(s => setResetChequeNoValue(s)) } inputRef={register({ required: true , maxLength: 6}) } />
                    {errors.d_Reset_Cheque_No && errors.d_Reset_Cheque_No.type === "required" && <span id="Err_msg">Cheque No. cannot be Blank</span>}
                    {errors.d_Reset_Cheque_No && errors.d_Reset_Cheque_No.type === "maxLength" && <span id="Err_msg">Max length is 6</span>}
                    {errors.d_Reset_Cheque_No && errors.d_Reset_Cheque_No.types && <span id="Err_msg">{errors.d_Reset_Cheque_No.types.message}</span>}
                </FormGroup>
            </div>
            
            <div className="Row">
                <FormGroup className="Col-1-3" label='Autopay Bank Code' labelFor="inputAutopay_BankCode">
                    <InputGroup id="inputAutopay_BankCode" value={AutopayBankCodeValue} defaultValue="" placeholder='Autopay Bank Code ...' onChange={utils.handleStringChange(s => setAutopayBankCodeValue(s)) } inputRef={register({ maxLength: 1}) } /> 
                    {errors.d_Autopay_BankCode && errors.d_Autopay_BankCode.types && <span id="Err_msg">{errors.d_Autopay_BankCode.types.message}</span>}
                    {errors.d_Autopay_BankCode && errors.d_Autopay_BankCode.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                </FormGroup>
            </div> 

            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            <div >Note : </div>
            <div >You may key in "1" or "TRAN" to reset all Payment Cheque No  / Autopay to blank</div>
        </form>
    )
}


interface PayRecCheqMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

function PayRecCheqMain({ gsb }: PayRecCheqMainProps) {


    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const imgdoubledown = <img className="svgdoubledownIcon" src={svgdoubledown} height="20" width="30" alt="doubledown" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    const history = useHistory()


    const [searchKey, setSearchKey] = useState("StkNo")

    const [showFilters, setShowFilters] = useState(false)
    const [searchStkNo, setsearchStkNo] = useState("")
    const [ShowWait, setShowWait] = useState(false)
    const [ChgPrintCheque, setChgPrintCheque] = useState(false)
    const [ChgAutopay, setChgAutopay] = useState(false)

    const [RptName, setRptName] = useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [currentCheqStatus, setcurrentCheqStatus] = useState({} as PrintChqInfo)


    const [selectedTabId, setSelectedTabId] = useState("list")

    const [BlankPrintChq, setBlankPrintChq] = useState({} as PrintChqInfo)
    const [currentMode, setcurrentMode] = useState("MenuMode")

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")
    const [isShowAlert3, setisShowAlert3] = useState(false)
    const [ShowAlert3Msg, setShowAlert3Msg] = useState([])

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [dateFormat, setdateFormat] = useState("")

    const [CHQ_TO_BANK, setCHQ_TO_BANK] = useState(false)

    const [isGenerate, setisGenerate] = useState(false)



    BlankPrintChq.d_Currency = "HKD"
    BlankPrintChq.d_Starting_Cheque_No = "1"
    BlankPrintChq.d_Bank_No = "1"
    BlankPrintChq.d_Reset_Cheque_No = "TRAN"
    BlankPrintChq.d_LPT = "XLPT1"
    BlankPrintChq.d_Autopay_BankCode = ""


    const [ProgressValue, setProgressValue] = useState(0)
        
    //for autopay
 

    const [CCHQ_FILE, setCCHQ_FILE] = useState(false)
    const [Auto_CCHQ_FILE, setAuto_CCHQ_FILE] = useState(false)

    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptLogName, setRptLogName] = useState("")   

    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)
    const [DataFormatValue, setDataFormatValue] = useState(true)
    const [ShowRpt, setShowRpt] = useState(false)  


    const [bankSelect, setBankSelect] = useState("");
    const [isBankAlertOpen, setIsBankAlertOpen] = useState(false); 
    
    const [effectiveDate, setEffectiveDate] = useState(utils.toCalendarFormat(TRAN_DATE));
    const [isAutoPayConfirmOpen, setIsAutoPayConfirmOpen] = useState(false);
    const [DateOfTrans, setDateOfTrans] = useState("")

 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("PayRecCheqMain disp user_key: ", res.data.Flag.user_key)
                //console.log("PayRecCheqMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("PayRecCheqMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("PayRecCheqMain disp GsbFlag: ", GsbFlag)
                //console.log("PayRecCheqMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("PayRecCheqMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("PayRecCheqMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("PayRecCheqMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("PayRecCheqMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setdateFormat(GsbFlag.dateFormat);

                setCHQ_TO_BANK(GsbFlag.CHQ_TO_BANK);
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
    useEffect(() => {
        (async () => {
            try {               
            

                    setEffectiveDate(utils.toCalendarFormat(TRAN_DATE));
            
            } catch (error) {
                //setCanPorcess(false)
                
            }
        })()
    
    }, [gsb, TRAN_DATE, SETL_DATE])
    

    useEffect(() => {
        if ( selectedTabId == "list" ) {

            setShowWait(true)
 
            ;

            (async () => {
                try {
                    //console.log("SmMastMain onsubmit called", data)
                    const res = await gsb.post('/Transaction',
                    {   sb_data: {
                        },
                        cPgmId: "PayRecTranEntry",
                        cAction: "getPaymentChqStatus",
                    });

                    //console.log("PayRecCheqMain res.data.data: ", res.data.data) 
                    setcurrentCheqStatus(res.data.data[0])
                    setBlankPrintChq(res.data.data[0])


                    if ( res.data.count > 0 ) {
                        setChgPrintCheque(false)
                        setChgAutopay(false)
                        setShowWait(false)
                    } else {

                    }
                } catch (error) {
                    utils.showError(error)
                }
                setShowWait(false)
            })()
        }

    }, [gsb, selectedTabId, ChgPrintCheque, ChgAutopay])


    const onPrintPaymentCheque = (PrintChq: PrintChqInfo) => {
        setShowWait(true)
        setRptName("")
        setRptNameNo(0)
        ;
        console.log("onPrintPaymentCheque PrintChq", PrintChq);
        (async () => {
            try {
                const res = await gsb.post('/Transaction', {
                    sb_data: PrintChq, 
                    cPgmId: "PayRecTranEntry",
                    cAction: "PayRecCheque",
                })                
                if ( res.data.ok ) {
                    //utils.showSuccess(res.data.data)
                    setisShowAlert1(true)
                    setShowAlert1Msg(res.data.data)
                    setRptName(res.data.RptName)
                    setRptNameNo(res.data.RptNameNo)
                    if ( res.data.count > 0 ) {
                        if (res.data.RptNameNo > 0 ) {
                            for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                                aRptNameNo.push({n: j});
                            }
                            setRptName(res.data.RptName.replace(".pdf",""))
                        }
                    }
                } else {
                    //utils.showWarn(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
        setChgPrintCheque(true)
}
    const onGenAutoPay = () => {
        setShowWait(true);
        setRptName("");
        setRptNameNo(0);
        
        console.log("onGenAutoPay executed with:", { bankSelect, effectiveDate });
        
        (async () => {
            try {
                const res = await gsb.post ('/Transaction', {
                    sb_data: {
                        BanKCode: bankSelect,
                        ChqType: "CHQ33",
                        EffectiveDate: effectiveDate 
                    }, 
                    cPgmId: "Cheque2Client",
                    cAction: "genAutoPayBoc", 
                });               

         
                    if (res.data.ok) {                        
                        setRstdata2([])
                        for (let j = 0; j < res.data.Rptdata.length; j++) {
                            Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                        }
                        setShowWait(false)
                        setShowNoRecord(false)
                        setShowRpt(true)
                         setRstdata(Rstdata2)
                        console.log("Rstdata2: ", Rstdata2) 
                         console.log(res.data.Rpthead1)
                       //setRptName2("")
                       setRptName(res.data.RptName)
                       setRptLogName(res.data.RptLogName)
                        console.log(res.data.RptNameNo)
                        setAuto_CCHQ_FILE(true) 
                    }
                
                    
                    else
                    {
                        setShowWait(false)
                        setShowNoRecord(true)
                        setShowRpt(false)
                        setAuto_CCHQ_FILE(true)
                        }
                } catch (error) {
                    setShowWait(false)
                    setShowNoRecord(true)
                    setShowRpt(false)
                        } finally {
                    setShowWait(false);
                }        
            })();
    
        setChgAutopay(true);
    };
    const onCHQ_TO_BANK = () => {
        setShowWait(true)
        setRptName("")
        setRptNameNo(0)
        ;
        console.log("onCHQ_TO_BANK ");
        (async () => {
            try {
                const res = await gsb.post('/Transaction', {
                    sb_data: {}, 
                    cPgmId: "PayRecTranEntry",
                    cAction: "PayRecChq2Bank",
                })                
                if ( res.data.ok ) {
                    //utils.showSuccess(res.data.data)
                    setisShowAlert1(true)
                    setShowAlert1Msg(res.data.data)
                } else {
                    //utils.showWarn(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
        setChgAutopay(true)
}

    const onChqProcess = async (PrintChq: PrintChqInfo) => {
        onPrintPaymentCheque(PrintChq)
    }
    const { t, i18n } = useTranslation()   

    const onResetChqProcess = async (PrintChq: PrintChqInfo) => {
        setShowWait(true)
        setRptName("")
        setRptNameNo(0)
        ;
        console.log("onResetChqProcess PrintChq", PrintChq);
        (async () => {
            try {
                const res = await gsb.post('/Transaction', {
                    sb_data: PrintChq, 
                    cPgmId: "PayRecTranEntry",
                    cAction: "ResetPaymentCheque",
                })                
                if ( res.data.ok ) {
                    //utils.showSuccess(res.data.data)
                    setisShowAlert1(true)
                    setShowAlert1Msg(res.data.data)
                } else {
                    //utils.showWarn(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
        if ( PrintChq.d_Reset_Cheque_No == "TRAN" ) {
            setChgAutopay(true)
        } else {
            setChgPrintCheque(true)
        }
    }


    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
    }        



    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>

    let RptNameaRef = <>
        { RptNameNo > 0 && <div> Download / Print &nbsp;
            {aRptNameNo.map((no, j) => 
                <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
            )}
        </div> }
        { RptNameNo <= 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>}
        <div className="Spacing-V-16" />
        Please download the Cheque file to Print at the above link !!
    </>

    // Keep your existing 'let' declaration intact
    let list = (
        <div >
            <div className="Spacing-V-16" />

           
            {RptName.trim().length > 0 && (
                <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>
                    Download{" "}
                </a>
            )}
                  &nbsp; &nbsp;{" "}
            {/*RptLogName.trim().length > 0 && (
              
                <a href="#" onClick={handleViewLogClick(RptLogName)}>
                    View Log
                </a>           
            )*/}
                   
           {RptLogName.trim().length > 0 && (
                <a target="_blank" rel="noopener noreferrer" 
                    href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>
                        View Log</a>
                )  
            }             
        </div>
    );

    let PrintChqSection = <PrintChqRtn gsb={gsb} currentPrintChq={BlankPrintChq} onChqProcess={onChqProcess} onCancel={() => { setcurrentMode("MenuMode") } } ></PrintChqRtn>

    let ResetChqSection = <ResetChqRtn gsb={gsb} currentPrintChq={BlankPrintChq} onResetChqProcess={onResetChqProcess} onCancel={() => { setcurrentMode("MenuMode") } } ></ResetChqRtn>


    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <div>
                        <H3>335 Print Payment Cheque / Autopay to Client</H3>
                    </div>
                    <div className="Spacing-V-16" />
                    {ShowWait && <div>{imgWait}</div> }
                    <div className="Spacing-V-16" />
                    { ( currentMode == "MenuMode" ) && <table>
                        <tr><td><Button className="Col-3-2" intent={currentCheqStatus.d_Cheque_Printed == 2 ? Intent.SUCCESS : "none"} icon="document" onClick={() => { setcurrentMode("PrintChqMode")  } }>Print Payment Cheque to Client</Button></td></tr>
                        <tr><td id="td_center">&nbsp;</td></tr>
                        {/*<tr><td><Button className="Col-3-2" disabled={! CHQ_TO_BANK} intent={currentCheqStatus.d_Generate_Chq_to_Bank == 2 ? Intent.SUCCESS : "none"} icon="document" onClick={() => { setisGenerate(true) } }>Generate Autopay Data</Button></td></tr>
                        {CHQ_TO_BANK && <tr><td id="td_center">&nbsp;</td></tr>}
                        <Alert
                            cancelButtonText="Cancel"
                            confirmButtonText="Generate"
                            canEscapeKeyCancel={true}
                            icon="flow-branch"
                            intent={Intent.SUCCESS}
                            isOpen={isGenerate}
                            onCancel={ () => setisGenerate(false) }
                            onConfirm={ () => { onCHQ_TO_BANK(); setisGenerate(false) } }
                        >
                            <p>
                                Are you sure to Generate Autopay Data ?
                            </p>
                        </Alert>     
                        */}

                        <tr><td></td></tr>
                        <tr><td></td></tr>
                        <tr>                            
                            <td>                                                         	
                                <Card interactive={true} className="Col-1-12">
                                    <H6>{t('AutoPay specific file')} </H6>   
                                    <div className="Spacing-V-16" />
                                        <Button 
                                            className="Col-3-2" 
                                            disabled={! CHQ_TO_BANK} 
                                            intent={currentCheqStatus.d_Generate_Chq_to_Bank == 2 ? Intent.SUCCESS : "none"} 
                                            icon="document" 
                                            onClick={() => { setisGenerate(true) } }
                                        >
                                            Generate Autopay Data
                                        </Button>
                                        <Alert
                                            cancelButtonText="Cancel"
                                            confirmButtonText="Generate"
                                            canEscapeKeyCancel={true}
                                            icon="flow-branch"
                                            intent={Intent.SUCCESS}
                                            isOpen={isGenerate}
                                            onCancel={ () => setisGenerate(false) }
                                            onConfirm={ () => { onCHQ_TO_BANK(); setisGenerate(false) } }
                                        >
                                            <p>
                                                Are you sure to Generate Autopay Data ?
                                            </p>
                                        </Alert>  


                                    <div className="Spacing-V-16" />                                   
 
                                               
                                    <div className="Row">
                                        <Button 
                                            className="Col-1-4" 
                                            disabled={Auto_CCHQ_FILE}   
                                            //             intent={currentSmentit.d_Generate_Chq_to_Bank == 2 ? Intent.SUCCESS : "none"} 
                                            icon="document" 
                                            onClick={() => { 
                                                if (!bankSelect || bankSelect.trim() === "") {
                                                    setIsBankAlertOpen(true);
                                                } else {
                                                    setIsAutoPayConfirmOpen(true); 
                                                }
                                            }}
                                        >
                                            {t('Generate AutoPlay specific File')}
                                        </Button>                                        
                                    </div>
                                    <div className="Row"> 
                                        <FormGroup 
                                            className="Col-1-3" 
                                            label={t('Effective Date')} 
                                            labelFor="inputTrans_Date"
                                            intent={(!effectiveDate || effectiveDate.trim() === "") ? Intent.DANGER : Intent.NONE}
                                        >
                                            <InputGroup 
                                                id="inputTrans_Date"   
                                                name="d_Trans_Date"
                                                type="date"
                                                placeholder="YYYY-MM-DD"
                                                leftIcon="calendar"
                                                value={effectiveDate}
                                                intent={(!effectiveDate || effectiveDate.trim() === "") ? Intent.DANGER : Intent.NONE}
                                                onChange={utils.handleStringChange(s => {
                                                    setEffectiveDate(s);
                                                    if (typeof setAuto_CCHQ_FILE === 'function') setAuto_CCHQ_FILE(false);
                                                    if (typeof setShowWait === 'function') setShowWait(false);
                                                    if (typeof setShowNoRecord === 'function') setShowNoRecord(false);
                                                    if (typeof setShowRpt === 'function') setShowRpt(false);
                                                    if (typeof setProgressValue === 'function') setProgressValue(0); 
                                                })}
                                            />      

                                            {/* Custom span error message */}
                                            {(!effectiveDate || effectiveDate.trim() === "") && (
                                                <span 
                                                    className="error-message" 
                                                    style={{ 
                                                        color: "#db3737",      
                                                        fontSize: "12px",     
                                                        marginTop: "5px",      
                                                        display: "block",      
                                                        fontWeight: 500 
                                                    }}
                                                >
                                                    {t("Please select an Effective Date!")}
                                                </span>
                                            )}
                                        </FormGroup>
                                    </div>
                                    <div className="Row">                                            
                                        <FormGroup className="Col-1-3" label="BankCode" labelFor="inputBankCode">  
                                            <HTMLSelect id="input_BankCode" name="d_BankCode"  
                                                className="Col-1-2"                                            
                                                onChange={utils.handleStringChange(s => setBankSelect(s))}   >
                                                <option value=""></option>
                                                <option value="HSBC">HSBC</option>
                                                <option value="BOC">BOC</option>
                                            </HTMLSelect>
                                        </FormGroup>
                                                    
                                        <Alert
                                            confirmButtonText="OK"
                                            isOpen={isBankAlertOpen}
                                            intent={Intent.WARNING}
                                            icon="warning-sign"
                                            onConfirm={() => setIsBankAlertOpen(false)}
                                        >
                                            <p>Please select a Bank before generating the file.</p>
                                        </Alert>                                   
                                        <Alert
                                            cancelButtonText="Cancel"
                                            confirmButtonText="Generate"
                                            canEscapeKeyCancel={true}
                                            icon="flow-branch"
                                            intent={Intent.SUCCESS}
                                            isOpen={isAutoPayConfirmOpen}
                                            onCancel={() => setIsAutoPayConfirmOpen(false)}
                                            onConfirm={() => { 
                                                onGenAutoPay(); 
                                                setIsAutoPayConfirmOpen(false); 
                                            }}
                                        >
                                            <p>Are you sure you want to Generate AutoPlay specific File?</p>
                                        </Alert>
                                    </div>
                                    {/* {ShowWait && <div>{imgWait}</div> } */}
                                    {ShowWait && <div className="TCol-Progress2">Progress ...</div> }
                                    {ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={false} value={ProgressValue} /></div>}
                                    {ShowNoRecord && <p>
                                        <div className="Spacing-V-16" />
                                        <div className="Row">
                                            <FormGroup className="Col-1-3"  >
                                                <span id="Err_msg">No Record found !!!</span>
                                            </FormGroup>
                                        </div>
                                    </p>
                                    }
                                    {ShowRpt && list}    





                                </Card>
                            </td>
                        </tr>  

                        <tr><td><Button className="Col-3-2" icon="document" onClick={() => { setcurrentMode("ResetChqMode")  } }>Reset Payment Cheque No. / Autopay to Blank</Button></td></tr>
                        <tr><td id="td_center">&nbsp;</td></tr>
                    </table> }
                    <div className="Spacing-V-16" />
                    { ( currentMode == "PrintChqMode" ) && <div >
                        {PrintChqSection}
                        {RptName.trim().length > 0 && RptNameaRef}
                    </div> }
                    { ( currentMode == "ResetChqMode" ) && <div >
                        {ResetChqSection}
                    </div> }
                    <div className="Spacing-V-16" />
                </Card>
                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert3}
                        onCancel={ () => setisShowAlert3(false) }
                        onConfirm={ () => { setShowAlert3Msg([]); setisShowAlert3(false) } }
                    >
                        <p>
                            {/*ShowAlert3Msg*/}
                            <div className="Spacing-V-16"></div>
                            {ShowAlert3Msg.map((Wmsg, j) => 
                                <div>{ShowAlert3Msg[j]}</div>
                            )}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default PayRecCheqMain